import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { LoadingController, NavParams, ModalController } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';

import { OrderComponent } from '../order/order.component';
import { ChatComponent } from '../chat/chat.component';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-add-coupon',
    templateUrl: './add-coupon.component.html',
    styleUrls: ['./add-coupon.component.scss'],
})
export class AddCouponComponent implements OnInit {

    coupon: any;
    orders: any = [];
    couponForm: FormGroup;
    unlimited: any = false;
    total_orders: any = 0;
    total: any = 0;

    constructor(
        public api: ApiService,
        public auth: AuthService,
        public loadingCtrl: LoadingController,
        public navParams: NavParams,
        public modalController: ModalController,
        private http: HttpClient,
        public formBuilder: FormBuilder
    ) {
        this.coupon = navParams.get('coupon');

        this.unlimited = false;

        this.couponForm = this.formBuilder.group({
            code: [this.coupon, [Validators.required]],
            available: [false, [Validators.required]],
            type: ['free_delivery', [Validators.required]],
            uses: [1, [Validators.required]],
            countryCode: [this.auth.countryCode,[Validators.required]]
        });
    }

    ngOnInit() { }

    changeUnlimited(e) {
        if (e.detail.checked) {
            this.unlimited = true;
        } else {
            this.unlimited = false;
        }
    }

    async loader() {
        return await this.loadingCtrl.create({
            spinner: 'lines-small',
            animated: true,
            mode: 'ios',
            translucent: false,
            cssClass: 'custom-class custom-loading',
        });
    }


    addCoupon() {
        let data = this.couponForm.value;
        console.log(data);

        if (this.unlimited) {
            data.uses = {
                unlimited: true
            };
        }

        this.api.addDocument('coupons', data).then(data => {
            this.modalController.dismiss();
        })
    }
}
